// Local translations
export const T = {
  en_GB: {
    templateStyle: "Template Style",
    templateStyleDescription: "Configure the visual style of the PDF",
    typography: "Typography",
    fontFamily: "Font Family",
    fontSize: "Font Size",
    selectFont: "Select a font",
    selectFontSize: "Select a size (default: 9pt)",
    tableStyling: "Table Styling",
    tableStyleType: "Table Style Type",
    selectTableStyle: "Select table style",
    borders: "Borders",
    alternatingRows: "Alternating Rows",
    tableHeaderBackground: "Table Header Background",
    tableHeaderText: "Table Header Text",
    tableAlternatingRowColor: "Alternating Row Color",
    none: "None",
    noneBlack: "None (black)",
    clear: "Clear",
    evenRowColorDescription: "Background color for even-numbered rows",
    save: "Save",
    saveStyle: "Saved",
    failedToSave: "Failed to save changes",
  },
  nb_NO: {
    templateStyle: "Malstil",
    templateStyleDescription: "Konfigurer den visuelle stilen for PDF-en",
    typography: "Typografi",
    fontFamily: "Skrifttype",
    fontSize: "Skriftstørrelse",
    selectFont: "Velg en skrifttype",
    selectFontSize: "Velg en størrelse (standard: 9pt)",
    tableStyling: "Tabellstyling",
    tableStyleType: "Tabellstiltype",
    selectTableStyle: "Velg tabellstil",
    borders: "Kantlinjer",
    alternatingRows: "Vekslende rader",
    tableHeaderBackground: "Tabelloverskrift bakgrunn",
    tableHeaderText: "Tabelloverskrift tekst",
    tableAlternatingRowColor: "Vekslende radfarge",
    none: "Ingen",
    noneBlack: "Ingen (svart)",
    clear: "Fjern",
    evenRowColorDescription: "Bakgrunnsfarge for partallsrader",
    save: "Lagre",
    saveStyle: "Lagret",
    failedToSave: "Kunne ikke lagre endringer",
  },
} as const;
